export default __webpack_public_path__ + "media/clock-o.5ad3d310.svg";